import '.f8{max-width:560px;}.ssr-plugin'
import '.c0{padding:48px;}.ssr-plugin'
import '.fa{height:calc(100vh - 124px);}.ssr-plugin'
import '.ag{box-sizing:border-box;}.ssr-plugin'
import '.o{display:flex;}.ssr-plugin'
import '.p{flex-direction:column;}.ssr-plugin'
import '.bb{justify-content:center;}.ssr-plugin'
import '.cr{margin-bottom:24px;}.ssr-plugin'
import '.b6{margin-bottom:72px;}.ssr-plugin'
import { styled } from 'inlines'
import { colors } from '../../utils/colors.js'
import { Button } from '../../components/Button.js'
import { Icon } from '../../assets/icons/index.js'
import { TABLET, MOBILE, HEIGHT } from '../../utils/breakpoints.js'
import { useVotingRegion } from '../../hooks/useVotingRegion.js'

export const StepThree = ({ step, setStep, dictionary }) => {
  const [votingRegion] = useVotingRegion()
  const voteType = votingRegion?.voteType
  const tutorialText1 =
    voteType === 'online'
      ? dictionary.tutorialCardLimit
      : voteType === 'call_suffix'
        ? dictionary.tutorialCallVoting
        : voteType === 'sms_text' || voteType === 'sms_suffix'
          ? dictionary.tutorialSMSVoting
          : dictionary.tutorialCardLimit
  const tutorialText2 =
    voteType === 'online'
      ? dictionary.tutorialLostVotes
      : voteType === 'call_suffix'
        ? dictionary.tutorialCallVotingCount
        : voteType === 'sms_text' || voteType === 'sms_suffix'
          ? dictionary.tutorialSMSVotingCount
          : dictionary.tutorialLostVotes
  return (
    <styled.div className="f8 c0 fa ag o p bb"
      id="onboarding-step-three-content"
      style={{
        [TABLET]: {
          padding: '24px',
        },
        [MOBILE]: {
          height: 'calc(100dvh - 124px)',
          boxSizing: 'border-box',
          justifyContent: 'flex-end',
        },
      }}
    >
      <styled.div
        style={{
          [MOBILE]: {
            marginTop: '0px',
            marginBottom: '0px',
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          },
        }}
      >
        <h2 className="cr">{tutorialText1}</h2>
        <styled.h3 className="b6"
          style={{
            color: `${colors.primary}`,
            [MOBILE]: { marginBottom: '24px' },
            [HEIGHT]: {
              marginBottom: '12px',
            },
          }}
        >
          {tutorialText2}
        </styled.h3>
      </styled.div>
      <Button
        ariaLabel={dictionary?.continueButton}
        id="onboarding-step-three-action-open-step-four"
        trailIcon={<Icon type="forwardIcon" color={colors.secondary} />}
        fullWidth
        onClick={() => setStep(step + 1)}
      >
        {dictionary?.continueButton}
      </Button>
    </styled.div>
  )
}
